<div class="pdf-transcription">
  @if (transcription?.conversationSummary; as summary) {
    <div class="pdf-transcription__summary">
      <b class="pdf-transcription__label">Summary:</b>
      <span class="pdf-transcription__summary-text" [innerHTML]="summary"></span>
    </div>
  }

  <div class="pdf-transcription__date">
    <div class="pdf-transcription__date-label">
      <img ngSrc="assets/icons/phone-solid.svg" priority alt="phone icon" height="15" width="15" />
      Conversation Began
    </div>
    <div class="pdf-transcription__date-value">
      {{ formatLongDate(transcription?.startDate || '') }}
    </div>
  </div>

  <div class="pdf-transcription__body">
    @for (paragraph of transcription?.paragraphs; track $index) {
      <div
        class="pdf-transcription__paragraph"
        [attr.data-owner]="paragraph.channel === EChannel.agent ? 'Agent' : userName"
        [ngClass]="paragraph.channel === EChannel.agent ? 'agent' : 'user'"
      >
        @for (word of paragraph.words; track $index) {
          {{ word.punctuatedWord }}
        }
      </div>
    }
  </div>
</div>
<div class="html2pdf__page-break"></div>
